export const isMacLike =
  globalThis.navigator?.platform.match(/iPad|Mac|iPhone|iPod/)
